interface TopPageData {
  page_path: string
  views: number
  unique_visitors: number
}

interface TopPagesProps {
  data: TopPageData[]
  loading: boolean
}

const PAGE_LABELS: Record<string, string> = {
  '/': 'Accueil',
  '/equipe': 'Équipe',
  '/actualites': 'Actualités',
  '/le-projet': 'Le projet',
  '/galerie': 'Galerie',
  '/contact': 'Contact',
  '/mentions-legales': 'Mentions légales',
  '/politique-confidentialite': 'Politique de confidentialité',
}

function getPageLabel(path: string): string {
  if (PAGE_LABELS[path]) return PAGE_LABELS[path]

  // Handle article slugs: /actualites/mon-article -> Actualités > mon-article
  if (path.startsWith('/actualites/')) {
    const slug = path.replace('/actualites/', '')
    return `Actualités > ${slug}`
  }

  return path
}

function TopPages({ data, loading }: TopPagesProps) {
  if (loading) {
    return (
      <div className="analytics-card">
        <h2 className="section-title">Pages les plus visitées</h2>
        <div className="chart-loading">Chargement...</div>
      </div>
    )
  }

  if (data.length === 0) {
    return (
      <div className="analytics-card">
        <h2 className="section-title">Pages les plus visitées</h2>
        <div className="chart-empty">Aucune donnée pour cette période</div>
      </div>
    )
  }

  return (
    <div className="analytics-card">
      <h2 className="section-title">Pages les plus visitées</h2>
      <table className="top-pages-table">
        <thead>
          <tr>
            <th>Page</th>
            <th>Vues</th>
            <th>Visiteurs uniques</th>
          </tr>
        </thead>
        <tbody>
          {data.map((page) => (
            <tr key={page.page_path}>
              <td className="top-pages-path">
                <span className="page-label">{getPageLabel(page.page_path)}</span>
                {PAGE_LABELS[page.page_path] && (
                  <span className="page-path-hint">{page.page_path}</span>
                )}
              </td>
              <td className="top-pages-value">{page.views}</td>
              <td className="top-pages-value">{page.unique_visitors}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default TopPages
